import 'C:\\Projects\\genkei\\zumeco\\static\\shared\\QuotationDoodle.tsx.esbuild-plugin-windicss.css';
import type { ComponentChildren } from 'preact';
export const isQuotationDoodle = location.pathname.startsWith('/doodles/quotation/');
export const QuotationDoodleHidden = isQuotationDoodle ? () => <></> : ({
  children
}: {
  children: ComponentChildren;
}) => <>{children}</>;
export const QuotationDoodleInert = isQuotationDoodle ? ({
  children
}: {
  children: ComponentChildren;
}) => <div inert className="contents">
        {children}
      </div> : ({
  children
}: {
  children: ComponentChildren;
}) => <>{children}</>;